
import Vue from 'vue';
// @ts-ignore
import PublicPortfolioConnectionsImportModalQuery from './apollo/PublicPortfolioConnectionsImportModal.gql';
// @ts-ignore
import ExpressDesireToImportConnectionsForPublicPortfolioUserMutation from './apollo/ExpressDesireToImportConnectionsForPublicPortfolioUser.gql';
import GmailIcon from '~/components/partials/public-portfolio/assets/gmail-logo.vue.svg';
import ConnectIllustration from '~/components/partials/public-portfolio/assets/connect-illustration.vue.svg';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import CloseIcon from '~/assets/svg/close.vue.svg';
import Modal from '~/components/common/Modal/Modal.vue';
import { buildQuery } from '~/components/utils/browser/url';

export default Vue.extend({
  name: 'PublicPortfolioConnectionsImportModal',
  components: { Modal, BravadoText, BravadoButtonV3, GmailIcon, ConnectIllustration, CloseIcon },
  apollo: {
    contactsSynced: {
      query: PublicPortfolioConnectionsImportModalQuery,
      update: data => data.currentUser.lastContactsSyncedAt,
    },
  },
  data(): { contactsSynced: string; googleRedirectUrl: string } {
    const googleRedirectQuery = buildQuery({
      fetch: 'true',
      dynamic_modal: this.$constants.dynamicModals.PUBLIC_PORTFOLIO_CONNECT_MODAL,
    });
    return {
      contactsSynced: '',
      googleRedirectUrl: `/users/fetch_contacts/google_oauth2?refferer=${process.env.internalBaseUrl}/portfolio/${
        this.$auth.user!.slug
      }${encodeURIComponent(googleRedirectQuery)}`,
    };
  },
  methods: {
    onBeforeOpen() {
      if (!this.contactsSynced) {
        this.$apollo.mutate({ mutation: ExpressDesireToImportConnectionsForPublicPortfolioUserMutation });
      }
    },
  },
});
